import r from "./index753.js";
import { withDirectives as s, openBlock as l, createElementBlock as t, withModifiers as n, normalizeClass as a, renderSlot as d, createElementVNode as p, toDisplayString as m, vShow as f } from "vue";
import u from "./index720.js";
const v = ["id", "aria-disabled", "aria-selected"];
function b(e, i, c, k, $, C) {
  return s((l(), t("li", {
    id: e.id,
    class: a(e.containerKls),
    role: "option",
    "aria-disabled": e.isDisabled || void 0,
    "aria-selected": e.itemSelected,
    onMousemove: i[0] || (i[0] = (...o) => e.hoverItem && e.hoverItem(...o)),
    onClick: i[1] || (i[1] = n((...o) => e.selectOptionClick && e.selectOptionClick(...o), ["stop"]))
  }, [
    d(e.$slots, "default", {}, () => [
      p(
        "span",
        null,
        m(e.currentLabel),
        1
        /* TEXT */
      )
    ])
  ], 42, v)), [
    [f, e.visible]
  ]);
}
var D = /* @__PURE__ */ u(r, [["render", b]]);
export {
  D as default
};
